import PropTypes from "prop-types";
import { FormControlLabel, RadioGroup, FormControl, FormLabel, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import Radio from "@mui/material/Radio";
import MDTypography from "components/MDTypography";
import { ErrorMessage } from "formik";
import colors from "assets/theme/base/colors";

const { primaryC } = colors;

const StyledRadio = styled(Radio)(() => ({
  color: primaryC.main,
  "&.Mui-checked": {
    color: primaryC.main,
  },
  "&:hover": {
    backgroundColor: `${primaryC.main}0a`,
  },
}));

const LOCATION_TYPE_OPTIONS = [
  {
    value: "hotel",
    label: "Hotel",
  },
  {
    value: "holidayhome",
    label: "Holiday Home",
  },
];

const LocationTypeSelector = ({
  value = "",
  onChange = () => {},
  name = "locationType",
  label = "Location Type:",
  error = false,
  disabled = false,
  required = false,
  ...rest
}) => {
  const handleChange = (event) => {
    if (onChange) {
      onChange(event.target.value, event);
    }
  };

  return (
    <Box sx={{ width: "100%", mb: 1.5 }}>
      <FormControl component="fieldset" error={error} disabled={disabled} sx={{ width: "100%" }}>
        <FormLabel
          component="legend"
          sx={{
            color: error ? "#d32f2f" : "inherit",
            fontSize: "14px",
            fontWeight: 400,
            mb: 1,
            "&.Mui-focused": {
              color: error ? "#d32f2f" : primaryC.main,
            },
          }}
        >
          {label} {required && "*"}
        </FormLabel>

        <Box
          sx={{
            border: `1px solid ${error ? "#d32f2f" : "#e0e0e0"}`,
            borderRadius: 1,
            padding: 2,
            backgroundColor: disabled ? "#f5f5f5" : "transparent",
          }}
        >
          <RadioGroup
            name={name}
            value={value || ""}
            onChange={handleChange}
            row
            sx={{ gap: 3 }}
            {...rest}
          >
            {LOCATION_TYPE_OPTIONS.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<StyledRadio size="small" />}
                label={
                  <Box>
                    <MDTypography variant="body2" fontWeight="medium">
                      {option.label}
                    </MDTypography>
                  </Box>
                }
                sx={{
                  margin: 0,
                  "& .MuiFormControlLabel-label": {
                    fontSize: "14px",
                  },
                }}
              />
            ))}
          </RadioGroup>
        </Box>

        {error && (
          <Box mt={0.75}>
            <MDTypography component="div" variant="caption" color="error" fontWeight="regular">
              <ErrorMessage name={name} />
            </MDTypography>
          </Box>
        )}
      </FormControl>
    </Box>
  );
};

// PropTypes for type checking
LocationTypeSelector.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  name: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
};

export default LocationTypeSelector;

// Export the options for external use if needed
export { LOCATION_TYPE_OPTIONS };
